(function(angular){
	'use strict';
	
	var alertObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		transclude: true,
		bindings: {
			type: '<'
		},
		controller: [AlertFunction],
		controllerAs: 'alert'
	};
	
	angular
		.module('alertModule')
		.component('alert', alertObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/alert/alert.html';
	}
	
	function AlertFunction() {
		var alert = this;

		alert.$onInit = function() {
			alert.iconType = 'alert-' + alert.type + '-32x32';
		};
	}
})(window.angular);